import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Phone, Menu, X, Sparkles } from "lucide-react";
import { site } from "../mock";

const nav = [
  { to: "/", label: "Accueil" },
  { to: "/retour-affectif", label: "Retour affectif" },
  { to: "/voyance", label: "Voyance" },
  { to: "/sorcier-puissant-orleans", label: "Sorcier" },
  { to: "/guerisseur", label: "Guérisseur" },
  { to: "/blog", label: "Villes" },
  { to: "/articles", label: "Articles" },
  { to: "/contact", label: "Contact" }
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  return (
    <header className="sticky top-0 z-50 bg-jetblack/95 backdrop-blur border-b border-[rgba(212,168,56,0.25)]">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6 flex items-center justify-between gap-4 py-4">
        <Link to="/" className="flex items-center gap-3 group">
          <div className="w-10 h-10 rounded-full gold-border-strong flex items-center justify-center">
            <Sparkles className="w-5 h-5 text-gold" />
          </div>
          <div className="leading-tight">
            <div className="font-display text-xl gold-gradient-text whitespace-nowrap">{site.name}</div>
            <div className="text-[11px] tracking-[0.25em] uppercase text-gold-deep whitespace-nowrap">Marabout • Voyant • Orléans</div>
          </div>
        </Link>

        <nav className="hidden xl:flex items-center gap-5">
          {nav.map((n) => (
            <Link
              key={n.to}
              to={n.to}
              className={`text-[13px] tracking-wide uppercase whitespace-nowrap transition-colors ${pathname === n.to ? "text-gold" : "text-gold-soft hover:text-gold"}`}
            >
              {n.label}
            </Link>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a href={`tel:${site.phoneRaw}`} className="btn-gold px-4 py-2 rounded-md text-sm flex items-center gap-2 whitespace-nowrap">
            <Phone className="w-4 h-4 shrink-0" /> {site.phone}
          </a>
          <a data-testid="header-whatsapp-btn" href={site.whatsapp} target="_blank" rel="noreferrer" className="btn-ghost-gold px-3 py-2 rounded-md text-sm flex xl:hidden min-[1440px]:flex items-center gap-2">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M20.52 3.48A11.94 11.94 0 0 0 12.04 0C5.5 0 .2 5.3.2 11.83c0 2.08.55 4.11 1.6 5.9L0 24l6.44-1.69a11.83 11.83 0 0 0 5.6 1.42h.01c6.53 0 11.83-5.3 11.83-11.83 0-3.16-1.23-6.13-3.36-8.42zM12.05 21.3h-.01a9.47 9.47 0 0 1-4.83-1.32l-.35-.21-3.82 1 .02-3.72-.23-.38a9.5 9.5 0 1 1 17.68-4.83c0 5.23-4.26 9.46-8.46 9.46z"/><path d="M17.34 14.4c-.29-.14-1.72-.85-1.98-.95-.27-.1-.46-.14-.65.15-.19.29-.75.94-.92 1.13-.17.19-.34.22-.63.07-.29-.14-1.23-.45-2.34-1.44a8.83 8.83 0 0 1-1.63-2c-.17-.29-.02-.44.13-.59.13-.13.29-.34.44-.51.15-.17.19-.29.29-.48.1-.19.05-.36-.02-.51-.07-.15-.65-1.57-.89-2.15-.23-.56-.47-.48-.65-.49h-.55c-.19 0-.5.07-.77.36-.27.29-1.02 1-1.02 2.44 0 1.44 1.05 2.83 1.2 3.03.15.19 2.07 3.16 5.02 4.43.7.3 1.25.48 1.68.62.7.22 1.34.19 1.84.11.56-.08 1.72-.7 1.96-1.38.24-.68.24-1.27.17-1.38-.07-.11-.26-.19-.55-.33z"/></svg>
            WhatsApp
          </a>
        </div>

        <button data-testid="mobile-menu-btn" className="xl:hidden text-gold" onClick={() => setOpen(!open)} aria-label="menu">
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="xl:hidden border-t border-[rgba(212,168,56,0.25)] bg-charcoal">
          <div className="container-narrow py-4 flex flex-col gap-3">
            {nav.map((n) => (
              <Link key={n.to} to={n.to} onClick={() => setOpen(false)} className="text-gold-soft py-2 uppercase text-sm tracking-wide">
                {n.label}
              </Link>
            ))}
            <div className="flex gap-2 pt-2">
              <a href={`tel:${site.phoneRaw}`} className="btn-gold flex-1 text-center py-2 rounded-md text-sm">{site.phone}</a>
              <a href={site.whatsapp} target="_blank" rel="noreferrer" className="btn-ghost-gold flex-1 text-center py-2 rounded-md text-sm">WhatsApp</a>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
